import React, {useContext} from 'react';
import {EditorContext} from '../container/LessonEditorContainer';
import {
  OPENENDED_QUESTION_NODE_TYPE,
  OpenEndedQuestionContent,
} from '../../../data/models/LessonContent/LessonContentBase';
import {NodeData} from '../models';
import NodeHandles from './NodeHandles';
import {getIconByType} from '../config';
import {lessonEditorText} from '../lessonEditorText';
import {Icon} from '../../../uiToolkit/Icon/Icon';

interface Props {
  data: NodeData;
}

const OpenEndedQuestionNode = ({data}: Props) => {
  const context = useContext(EditorContext);

  const onClick = (e: any) => {
    context.setSelectedNode(data.payload, data.type);
    e.stopPropagation();
  };

  const nodeContent = data.payload as OpenEndedQuestionContent;

  return (
    <NodeHandles>
      <div
        className={`EditorCard OpenEndedQuestionCard ${
          context.selectedNode?.internalId === data.payload.internalId
            ? 'SelectedEditorCard'
            : ''
        }`}
        onClick={onClick}>
        {!nodeContent.textAreaAnswerEnabled &&
          !nodeContent.attachmentAnswerEnabled && (
            <div className="Line">
              <p>
                {lessonEditorText.openEndedQuestionErrorBothPromptsDisabled}
              </p>
            </div>
          )}
        {nodeContent.textAreaAnswerEnabled && (
          <div className="Line">
            {/* <img src={getIconByType(OPENENDED_QUESTION_NODE_TYPE)} /> */}
            <Icon
              name={'open-ended-question-icon.svg'}
              className="openEndedQuestionIcon"
            />
            <p>{nodeContent.textAreaAnswerPrompt}</p>
          </div>
        )}
        {nodeContent.attachmentAnswerEnabled && (
          <div className="Line">
            <img src={getIconByType(OPENENDED_QUESTION_NODE_TYPE)} />
            <p>{nodeContent.attachmentAnswerPrompt}</p>
          </div>
        )}
      </div>
    </NodeHandles>
  );
};

export default OpenEndedQuestionNode;
